//Import dependencies
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

(function($){
	var checkedPrograms = 0;

	//Update the shelf with any pre-checked items
	$('.program-compare input:checkbox:checked').each(function() {
		programCompareSelect($(this));
	});

	//Program box clicks to toggle selection
	$(document).on('click', '.program-compare .program .content', function(e) {
		e.preventDefault();

		//Find the input
		let $input = $(this).find('input');

		if (($input).attr('checked')) {
			programCompareDeselect($input);
		}
		else {
			programCompareSelect($input);
		}
	});

	//Shelf remove clicks to deselect
	$(document).on('click', '#compare-shelf .remove', function(e) {
		e.preventDefault();

		let $input = $(`.program-compare .program input[value=${$(this).attr('data-program')}]`);

		programCompareDeselect($input);
	});

	//Listen for filtering, to remove the selected items
	$(document).on('filterComplete', function(e) {
		programCompareDeselectAll();
	});

	//Listen for compare click
	$(document).on('click', '#compare-shelf .submit .button', function(e) {
		if (checkedPrograms < 1) {
			e.preventDefault();

			let tip = $('#compare-shelf .submit .button')[0]._tippy;
			tip.show();
		}
	});

	//Initialize tooltips
	tippy('#compare-shelf .info i', {
		trigger: 'click',
		maxWidth: 132,
		size: 'large',
		theme: 'oztrekk'
	});

	tippy('#compare-shelf .submit .button', {
		trigger: 'manual',
		maxWidth: 132,
		size: 'large',
		theme: 'oztrekk'
	});

	/**
	 * Check a program box, update the shelf and appropriate urls
	 *
	 * @param  jQuerySelector  $input  The target checkbox
	 */
	function programCompareSelect($input) {
		//Don't allow more than the maximum checked
		if ($('.program-compare').hasClass('maxChecked')) return;

		$input.attr('checked', true);
		checkedPrograms++;

		//No more can be checked
		if (checkedPrograms == 4) {
			$('.program-compare').addClass('maxChecked');
		}

		//Add the program details to the shelf
		let content = '<div class="titles">';
		content += `<small>${$input.attr('data-university')}</small>`;
		content += `<p>${$input.attr('data-title')}</p></div>`;
		content += `<a class="remove" data-program="${$input.val()}">`;
		content += '<i class="far fa-times"></i></a>';

		$('#compare-shelf .bucket.empty').first().removeClass('empty').html(content);

		//Update the URL
		programCompareUpdateUrls();
	}

	/**
	 * Uncheck a program box, update the shelf and approprate urls
	 *
	 * @param  jQuerySelector  $input  The target checkbox
	 */
	function programCompareDeselect($input) {
		$input.attr('checked', false);
		checkedPrograms--;

		//Remove program details from the shelf
		let $bucket = $(`#compare-shelf .bucket .remove[data-program=${$input.val()}]`).parents('.bucket');
		$bucket.addClass('empty').html('');

		//Now more can be checked
		$('.program-compare').removeClass('maxChecked');

		programCompareUpdateUrls();
	}

	/**
	 * Uncheck all program boxes
	 */
	function programCompareDeselectAll() {
		//Empty the buckets
		$('#compare-shelf .bucket').addClass('empty').html('');

		//Remove maxChecked class
		$('.program-compare').removeClass('maxChecked');

		//Reset count
		checkedPrograms = 0;

		programCompareUpdateUrls();
	}

	/**
	 * Update the URLs for the compare
	 */
	function programCompareUpdateUrls() {
		//Only on pages with the shelf
		if ($('#compare-shelf').length < 1) return;

		//Find the button
		let $button = $('#compare-shelf .submit .button');

		let url = $button.attr('data-href');
		let querystring = '';

		//Get the program IDs
		let programs = [];

		$('.program-compare input:checkbox:checked').each(function() {
			programs.push(this.value);
		});

		if (programs.length) {
			querystring += `programs=${programs.join(',')}&`;
		}

		//Get params from the filter
		$('#filter-form select').each(function() {
			let val = $(this).val();

			if (val && val.length) {
				querystring += `${$(this).attr('name').replace('[]', '')}=${val.join(',')}&`;
			}
		});

		//Keyword
		let keyword = $('#keyword-filter').val();
		if (keyword && keyword.length) {
			querystring += `_keyword=${keyword}&`;
		}

		//Page
		if ($('.program-compare .program').length > 9) {
			querystring += `pages=${Math.ceil($('.program-compare .program').length / 9)}`;
		}

		//If there are query arguments, prepend the question mark
		if (querystring.length) {
			querystring = `?${querystring}`;
			querystring = querystring.replace(/([&\s]+$)/g, '');
		}

		//Update the url
		url += `${querystring}`;

		if (window.history.pushState) {
			let newUrl = new URL(window.location.href);
			newUrl.search = `${querystring}`;
			window.history.replaceState({path: newUrl.href}, '', newUrl.href);
		}

		//Update the href
		$button.attr('href', url);
	}

})(jQuery);
